<main class="main" id="top">
  <div class="container" data-layout="container">

    <nav class="navbar navbar-light navbar-glass navbar-top sticky-kit navbar-expand-lg">

      <button class="btn navbar-toggler-humburger-icon navbar-toggler mr-1 mr-sm-3" type="button" data-toggle="collapse" data-target="#navbarStandard" aria-controls="navbarStandard" aria-expanded="false" aria-label="Toggle Navigation"><span class="navbar-toggle-icon"><span class="toggle-line"></span></span></button>
      <a class="navbar-brand mr-0">
        <div class="d-flex align-items-center">
          <div class="logo mr-5">
            <img style="height:60px" src="../../../assets/img/logos/welt_logo.png" />
          </div>

          <div class="search-box">
            <form class="position-relative">
              <input id="globalSearch" class="form-control search-input" type="text" placeholder="Search..." autocomplete="off" name="globalSearch"
                     [(ngModel)]="globalSearch" (input)="showSearchedData();showRecentData()" (focusout)="closeRecentDropDown()" appTrimLeft />
              <span class="fas fa-search search-box-icon"></span>
            </form>
            <button class="btn-close position-absolute top-50 translate-middle shadow-none p-1 mr-1 fs--2 right-15 d-none btn-recent-close" type="button" (click)="closeRecentDropDown();resertGlobalSearch()"></button>
            <div class="dropdown-menu-recent dropdown-menu border font-base left-0 mt-2 py-0 overflow-hidden" style="min-width: 400px">
              <div class="scrollbar perfect-scrollbar py-3" style="max-height: 24rem;">
                <div *ngIf="seachOpe==1">
                  <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2" *ngIf="searchedProspectsList?.length>0">Requests</h6>
                  <div *ngIf="searchedProspectsList?.length>0">
                    <div *ngFor="let p of searchedProspectsList" class="bg-hover">
                      <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/requestdetail/{{p.id}}/Overview">
                        <div class="d-flex align-items-center">
                          <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                          <div class="font-weight-normal search-menu">{{p.customerName}} - {{p.name}}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!--project-->
                  <hr class="bg-200" *ngIf="searchedProjectsList?.length>0 && searchedProspectsList?.length>0" />
                  <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2" *ngIf="searchedProjectsList?.length>0">Jobs</h6>
                  <div *ngIf="searchedProjectsList?.length>0">
                    <div *ngFor="let p of searchedProjectsList" class="bg-hover">
                      <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/jobdetail/{{p.id}}/Overview">
                        <div class="d-flex align-items-center">
                          <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                          <div class="font-weight-normal search-menu">{{p.customerName}} - {{p.name}}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <!--estimate-->
                  <div *ngIf="searchedEstimatesList?.length>0">
                    <hr class="bg-200" *ngIf="searchedEstimatesList?.length>0 && (searchedProjectsList?.length>0 || searchedProspectsList?.length>0)" />
                    <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Estimates</h6>
                    <div *ngIf="searchedEstimatesList?.length>0">
                      <div *ngFor="let e of searchedEstimatesList" class="bg-hover">
                        <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/estimatedetails/{{e.id}}">
                          <div class="d-flex align-items-center">
                            <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                            <div class="font-weight-normal search-menu">{{e.customerName}} - {{e.name}}</div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!--invoice-->
                  <div *ngIf="searchedInvoicesList?.length>0">
                    <hr class="bg-200" *ngIf="searchedInvoicesList?.length>0 && (searchedEstimatesList?.length>0 || searchedProjectsList?.length>0 || searchedProspectsList?.length>0)" />
                    <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2" *ngIf="searchedInvoicesList?.length>0">Invoices</h6>
                    <div *ngIf="searchedInvoicesList?.length>0">
                      <div *ngFor="let i of searchedInvoicesList" class="bg-hover">
                        <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/invoicedetail/{{i.id}}">
                          <div class="d-flex align-items-center">
                            <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                            <div class="font-weight-normal search-menu">{{i.customerName}} - {{i.name}}</div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div *ngIf="searchData?.length==0">
                      <div class="dropdown-item fs--1 px-card py-1 hover-primary text-center" style="color:#9da9db!important">No results found</div>
                    </div>
                  </div>
                  <!--co-->
                  <div *ngIf="searchedCOList?.length>0">
                    <hr class="bg-200" *ngIf=" searchedCOList?.length>0  && (searchedEstimatesList?.length>0 || searchedProjectsList?.length>0 || searchedProspectsList?.length>0 || searchedInvoicesList?.length>0)" />
                    <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2" *ngIf="searchedCOList?.length>0">Change Orders</h6>
                    <div *ngIf="searchedCOList?.length>0">
                      <div *ngFor="let co of searchedCOList" class="bg-hover">
                        <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/changeorderdetail/{{co.id}}">
                          <div class="d-flex align-items-center">
                            <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                            <div class="font-weight-normal search-menu">{{co.customerName}} - {{co.name}}</div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div *ngIf="searchData?.length==0">
                      <div class="dropdown-item fs--1 px-card py-1 hover-primary text-center" style="color:#9da9db!important">No results found</div>
                    </div>
                  </div>

                  <!--po-->
                  <div *ngIf="searchedPOList?.length>0">
                    <hr class="bg-200" *ngIf=" searchedPOList?.length>0  && (searchedEstimatesList?.length>0 || searchedProjectsList?.length>0 || searchedProspectsList?.length>0 || searchedInvoicesList?.length>0 || searchedCOList?.length>0)" />
                    <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2" *ngIf="searchedPOList?.length>0">Purchase Orders</h6>
                    <div *ngIf="searchedPOList?.length>0">
                      <div *ngFor="let po of searchedPOList" class="bg-hover">
                        <a class="dropdown-item fs--1 px-card py-1 hover-primary" (click)="closeRecentDropDown()" routerLink="/purchaseorderdetail/{{po.id}}">
                          <div class="d-flex align-items-center">
                            <span class="fas fa-circle mr-2 text-300 fs--2"></span>
                            <div class="font-weight-normal search-menu">{{po.name}}</div>
                          </div>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div *ngIf="searchData?.length==0">
                    <div class="dropdown-item fs--1 px-card py-1 hover-primary text-center" style="color:#9da9db!important">{{searchText}}</div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </a>
      <div class="collapse navbar-collapse scrollbar ml-3" id="navbarStandard">
        <ul class="navbar-nav" data-top-nav-dropdowns="data-top-nav-dropdowns">
          <span *ngFor="let menu of menus">
          <li class="nav-item" [hidden]="menu.submenus.length>0">
            <a class="nav-link " role="button" [routerLink]="menu.url">{{menu.name}}</a>
          </li>
          <li class="nav-item dropdown" [routerLinkActive]="['link-active']" [hidden]="menu.submenus.length==0 || menu.multipleRowOpe">

            <!--dropdown-on-hover-->
            <a class="nav-link dropdown-toggle" id="submenu-{{menu.name}}" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{menu.name}}</a>
            <div class="dropdown-menu dropdown-menu-card p-1" aria-labelledby="submenu-{{menu.name}}">
              <div *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length!=0">
                <div class="bg-white rounded-soft pt-1"><a class="dropdown-item menu" [routerLink]="sbm.url">{{sbm.name}}</a></div>
                <a *ngFor="let thr of sbm.threemenus" class="nav-link  py-1 text-700 font-weight-medium" [routerLink]="thr.url">{{thr.name}}</a>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown" [routerLinkActive]="['link-active']" [hidden]="menu.submenus.length==0 || !menu.multipleRowOpe">
            <!--dropdown-on-hover-->
            <a class="nav-link dropdown-toggle" id="submenu-{{menu.name}}" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{menu.name}}</a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-card" aria-labelledby="submenu-{{menu.name}}">
              <div class="card navbar-card-pages shadow-none">
                <div class="card-body scrollbar perfect-scrollbar max-h-dropdown">
                  <img class="position-absolute b-0 r-0" src="../assets/img/illustrations/authentication-corner.png" width="130" alt="" />
                  <div *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length!=0">
                    <a class="dropdown-item menu" [routerLink]="sbm.url">{{sbm.name}}</a>
                  </div>
                  <div class="row">
                    <div class="col-6 col-md-4" *ngFor="let sbm of menu.submenus" [hidden]="sbm?.threemenus?.length==0">
                      <div class="nav flex-column">
                        <div class="nav-link py-1 text-900 font-weight-bold mt-3" *ngIf="sbm.threemenus?.length!=0">{{sbm.name}}</div>
                        <a class="nav-link py-1 text-700 font-weight-medium" *ngIf="sbm.threemenus?.length==0" [routerLink]="sbm.url">{{sbm.name}}</a>
                        <a *ngFor="let thr of sbm.threemenus" class="nav-link menu py-1 text-700 font-weight-medium" [routerLink]="thr.url">{{thr.name}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          </span>
        </ul>
      </div>


      <ul class="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center">







        <li class="nav-item d-none d-sm-block mr-1">

          <span class="cursor-pointer fs-18" (click)="showReport();hideCollapse();" style="margin-top: -2px; padding: 0.1875rem 0.55rem;" data-toggle="tooltip" data-placement="top" title="Feedback">
            <i class="fas fa-comment-alt"></i>
          </span>

        </li>


        <li class="nav-item dropdown">
          <a class="nav-link pr-0" id="navbarDropdownUser" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="avatar avatar-xl">
              <img class="rounded-circle" *ngIf="_authService.image()?.length>0" src="{{_authService.image()}}" />
              <span *ngIf="_authService.image()?.length==0" class="circle-user-icon"><i class="fas fa-user"></i></span>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="navbarDropdownUser">
            <div class="bg-white rounded-soft py-2" id="navbarDropdownUser">
              <div class="dropdown-item font-weight-bold">{{_authService.firstName()}} {{_authService.lastName()}}</div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item hoverable" routerLink="/account-settings" (click)="hideCollapse()">Account Settings</a>
              <a class="dropdown-item hoverable cursor-pointer" (click)="editPassword();hideCollapse();">Change Password</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item hoverable cursor-pointer" (click)="logOut()">Logout</a>
            </div>
          </div>
        </li>
      </ul>
    </nav>


    <div class="content" style="margin-left:unset!important;">

      <router-outlet></router-outlet>
      <footer></footer>
      <!-- Modal Password-->
      <div class="modal fade z-index10000 px-0" id="modal_password"
           tabindex="-1" role="dialog" aria-labelledby="modal_password" data-backdrop="static" data-keyboard="true"
           aria-hidden="true">
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="modal-dialog modal-width-341px" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="mb-0 modal-title" id="exampleModalLabel">
                  Change Password
                  <br />
                </h5>
                <button class="close" type="button" aria-label="Close" id="X-ModalActivity" data-dismiss="modal">
                  <span class="font-weight-light" aria-hidden="true">&times;</span>
                </button>
              </div>
              <form [formGroup]="userPasswordForm" (ngSubmit)="onSubmit()">
                <div class="modal-body modal-body-padding">
                  <div class="validation m-0">
                    {{errorPassword}}
                  </div>
                  <div class="form-group">
                    <label for="old-password">Old Password <span class="text-danger">*</span></label>
                    <input class="form-control form-control-sm" autocomplete="new-password" id="oldPassword" type="password" formControlName="oldPassword" tabindex="6" autofocus required (keyup)="onPasswordKeyup()">
                  </div>
                  <div class="form-group">
                    <label for="currentPassword">New Password <span class="text-danger">*</span></label>
                    <input type="password" id="newPassword" autocomplete="new-password" title="New Password" class="form-control form-control-sm" formControlName="newPassword" tabindex="7" autofocus required (keyup)="onPasswordKeyup()" />
                  </div>
                  <div class="form-group">
                    <label for="confirmPassword">Confirm password <span class="text-danger">*</span></label>
                    <input type="password" id="confirmPassword" autocomplete="new-password" title="Confirm Password" class="form-control form-control-sm" formControlName="confirmPassword" tabindex="8" autofocus required />
                  </div>
                  <div class="password-validaitons font-size12px mt-2-3">
                    <div class="mt-1 text-danger"
                         *ngIf="(userPasswordForm.value.oldPassword?.length>=6 && userPasswordForm.value.newPassword?.length>=6 && userPasswordForm.value.oldPassword == userPasswordForm.value.newPassword)">
                      <span class="mr-1">
                        <i class="fas fa-info-circle"></i>
                      </span>
                      Old passwords cannot be reused
                    </div>
                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordForm.value.newPassword && userPasswordForm.value.newPassword?.length>=6) ? 'text-success' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span> Minumum password length is 6
                    </div>
                    <div class="mt-1">
                      <span class="mr-1"
                            [ngClass]="(userPasswordForm.value.newPassword &&  userPasswordForm.value.confirmPassword && userPasswordForm.value.newPassword?.length>=6 && userPasswordForm.value.confirmPassword?.length>=6
                      && userPasswordForm.value.newPassword== userPasswordForm.value.confirmPassword  ) ? 'text-success ' : 'text-muted'">
                        <i class="fas fa-check-circle"></i>
                      </span> Password matches Confirm Password
                    </div>
                  </div>
                </div>
                <div class="modal-footer justify-content-end">
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-sm btn-falcon-default mr-2" data-dismiss="modal">Close</button>
                      <button class="btn btn-primary float-right btn-sm" contextmenu=""
                              [disabled]="!userPasswordForm.valid || userPasswordForm.value.newPassword?.length<6  || (userPasswordForm.value.oldPassword==userPasswordForm.value.newPassword && userPasswordForm.value.oldPassword==userPasswordForm.value.confirmPassword ) || (userPasswordForm.value.newPassword!= userPasswordForm.value.confirmPassword)">
                        <div class="g_spinner" *ngIf="spinner"></div>Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!---->
      <!-- Modal Report issue-->
      <div class="modal fade px-0" id="modal_report_issue" tabindex="-1" role="dialog" aria-labelledby="modal_activity" data-backdrop="static" data-keyboard="true" aria-hidden="true">
        <div class="modal-dialog " role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="mb-0 modal-title" id="exampleModalLabel">
                Send feedback
                <br />
              </h5>
              <button class="close" type="button" aria-label="Close" id="X-ModalActivity" data-dismiss="modal">
                <span class="font-weight-light" aria-hidden="true">&times;</span>
              </button>
            </div>
            <div [style.opacity]="spinner ? '0.8;' : '1'">
              <div class="modal-body">
                <div class="row">
                  <div class="col-12 mb-1">
                    <span>Describe your issue or suggestion</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group has-feedback">
                      <textarea id="reportIssue" class="form-control font-weight-light" title="Report" alt="Report" placeholder="Tell us how we can improve our software." [(ngModel)]="reportIssue" rows="4" tabindex="1" autofocus maxLength="500"></textarea>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group has-feedback">
                      <input type="file" #myfileInput (change)="fileChangeEvent(myfileInput.files)" class="form-control-file form-control-sm p-0" id="myfileInput" tabindex="2" multiple />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-falcon-default btn-sm" data-dismiss="modal">Close</button>
                <button class="btn btn-sm btn-primary" id="reportSend" (click)="sendReport()" [disabled]="!reportIssue || fileOpe"> Send</button>
              </div>
            </div>
            <ngx-loading [show]="spinner" style="opacity:0.5" class="z-index1000"></ngx-loading>
          </div>
        </div>
      </div>
      <!---->

    </div>
</div>
</main>

